import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import ScrollableRow from './ScrollableRow';
import ViewAllLink from './ViewAllLink';
import PodcastCard from './PodcastCard';
import { LatestItemCount, LatestItemTitle } from './styled-components';
import { countLatestItems } from '../utils/common';
import { pages } from '../../config';

const Wrapper = styled.div``;

const StyledPodcastCard = styled(PodcastCard)`
  flex: 0 0 257px;
`;

interface Props {
  title?: string;
}

export default function LatestPodcasts({ title = 'Listen to Earth.fm artist talks' }: Props) {
  const data = useStaticQuery<Queries.LatestPodcastsQuery>(graphql`
    query LatestPodcasts {
      allWpPodcast(
        sort: { date: DESC }
        limit: 12
        filter: { podcastSettings: { isInterviewEpisode: { eq: true } } }
      ) {
        nodes {
          ...PodcastCardData
        }
        totalCount
      }
    }
  `);

  const newItemCount = React.useMemo(
    () => countLatestItems(data.allWpPodcast.nodes),
    [data.allWpPodcast.nodes],
  );

  const latestItemText = React.useMemo(() => {
    if (newItemCount === 0) {
      return '';
    }
    if (newItemCount === 1) {
      return `${newItemCount} new episode published this month.`;
    }
    return `${newItemCount} new episodes published this month.`;
  }, [newItemCount]);

  return (
    <Wrapper>
      <LatestItemTitle>{title}</LatestItemTitle>
      <LatestItemCount>{latestItemText}</LatestItemCount>
      <ScrollableRow title={title}>
        {data.allWpPodcast.nodes.map((podcast) => (
          <StyledPodcastCard key={podcast.id} data={podcast} forceIconsStyle />
        ))}
      </ScrollableRow>
      <ViewAllLink link={pages.podcast}>View all podcasts</ViewAllLink>
    </Wrapper>
  );
}
